export const MAX_PRODUCT_IMAGES = 8;

export const STORAGE_UNIT_OPTIONS = [
  { value: 'cbm', label: 'متر مكعب' },
  { value: 'sqm', label: 'متر مربع' },
];

export const BILLING_UNIT_OPTIONS = [
  { value: 'cbm', label: 'متر مكعب' },
  { value: 'sqm', label: 'متر مربع' },
  { value: 'free', label: 'مجاني' },
];

export function storageUnitLabel(unit) {
  if (unit === 'sqm') return 'متر مربع';
  if (unit === 'cbm') return 'متر مكعب';
  if (unit === 'free') return 'مجاني';
  return '—';
}

export function movementTypeLabel(type) {
  const map = {
    inbound: 'إدخال',
    adjust: 'تعديل',
    reserve: 'قيد البيع',
    release: 'إلغاء حجز',
    sell: 'بيع',
    restock: 'إعادة للمخزون',
  };
  return map[type] || type || '—';
}

export function formatQty(n) {
  const v = Number(n);
  return Number.isFinite(v) ? String(v) : '0';
}

export function formatMoney(n, symbol) {
  const v = Number(n);
  const amount = Number.isFinite(v)
    ? v.toLocaleString('ar-SA', { maximumFractionDigits: 2 })
    : '0';
  return symbol ? `${amount} ${symbol}` : amount;
}

export function productThumb(images) {
  if (!Array.isArray(images) || !images.length) return null;
  const first = String(images[0] || '').trim();
  return first || null;
}

export function stockSummaryText(row) {
  const available = Number(row?.qty_available ?? 0) || 0;
  const reserved = Number(row?.qty_reserved ?? 0) || 0;
  const onHand = Number(row?.qty_on_hand ?? 0) || 0;
  return `${available} متاح · ${reserved} قيد البيع · ${onHand} في المستودع`;
}

export function warehouseGoodsTotal(lines) {
  if (!Array.isArray(lines)) return 0;
  return lines.reduce((sum, line) => {
    const qty = Number(line?.qty) || 0;
    const price = Number(line?.selling_price) || 0;
    return sum + qty * price;
  }, 0);
}

export function warehouseCustomerTotal(goodsTotal, shippingRate, handlingFee) {
  return (Number(goodsTotal) || 0) + (Number(shippingRate) || 0) + (Number(handlingFee) || 0);
}

/** True when رسوم التجهيز is already in customer COD, so it must not be deducted from the merchant. */
export function handlingIncludedInCustomerTotal(order) {
  const handling = Number(order?.handling_fee) || 0;
  if (handling <= 0) return true;
  const goods = Number(order?.price) || 0;
  const shipping = Number(order?.shipping_cost != null ? order.shipping_cost : order?.shipping_rate) || 0;
  const total = Number(order?.total_price) || 0;
  return Math.abs(total - (goods + shipping + handling)) < 0.02;
}

export function merchantHandlingDeduction(order) {
  const handling = Number(order?.handling_fee) || 0;
  if (handling <= 0 || handlingIncludedInCustomerTotal(order)) return 0;
  return handling;
}

export const WAREHOUSE_ORDER_BADGE_LABEL = 'المستودع';

export function isWarehouseOrder(order) {
  return String(order?.fulfillment_source || '') === 'warehouse';
}

export function chargeStatusLabel(status) {
  const map = {
    due: 'مستحق',
    invoiced: 'مفوتر',
    settled: 'مسدد',
    waived: 'معفى',
  };
  return map[status] || status || '—';
}

export function canAdjustWarehouseCharge(charge) {
  if (!charge) return false;
  if (charge.settlement_id) return false;
  return String(charge.status) === 'due';
}

export function monthlyStorageAmount(space) {
  if (!space || space.billing_unit === 'free') return 0;
  const units = Number(space.allocated_units) || 0;
  const rate = Number(space.rate_per_unit) || 0;
  if (units <= 0 || rate <= 0) return 0;
  return Math.round(units * rate * 100) / 100;
}

export function formatPeriod(start, end) {
  if (!start) return '—';
  const s = String(start).slice(0, 10);
  const e = end ? String(end).slice(0, 10) : '';
  return e && e !== s ? `${s} → ${e}` : s;
}

export const WAREHOUSE_MERCHANT_REPORT_TYPE = 'warehouse_merchant';
export const WAREHOUSE_COMPANY_REPORT_TYPE = 'warehouse_company';

export function merchantCanSeeWarehouse(settings) {
  return Number(settings?.warehouses_enabled) === 1 && Number(settings?.merchant_has_warehouse) === 1;
}

export function warehouseSettlementNet({
  deliveredAmount = 0,
  returnedWithFeeAmount = 0,
  handlingFee = 0,
  storageCharges = 0,
} = {}) {
  return (Number(deliveredAmount) || 0)
    - (Number(returnedWithFeeAmount) || 0)
    - (Number(handlingFee) || 0)
    - (Number(storageCharges) || 0);
}

export function skuStockFlowText(row) {
  return `${formatQty(row?.qty_opening)} بداية · ${formatQty(row?.qty_inbound)} إدخال · ${formatQty(row?.qty_sold)} بيع · ${formatQty(row?.qty_restocked)} مرتجع · ${formatQty(row?.qty_closing)} نهاية`;
}
